(function () {
  function initialize(root) {
    if (root.dataset.vsReady) return;
    root.dataset.vsReady = 'true';
    var form = root.querySelector('form');
    var status = root.querySelector('[data-vs-status]');
    var cards = Array.from(root.querySelectorAll('[data-vs-coffee]'));
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var brew = form.elements.brew.value;
      var flavor = form.elements.flavor.value;
      var format = form.elements.format.value;
      var grind = format === 'beans' ? 'whole bean' : brew === 'press' ? 'coarse' : brew === 'espresso' ? 'espresso' : 'standard';
      var matches = [];
      cards.forEach(function (card) {
        var item = JSON.parse(card.querySelector('[data-vs-product]').textContent);
        var isPod = /pod|capsule/i.test(item.type);
        var grindIndex = item.options.findIndex(function (name) { return name.toLowerCase() === 'grind'; });
        var variant = item.variants.find(function (v) {
          if (!v.available) return false;
          if (brew === 'pods') return isPod;
          if (isPod) return false;
          if (grindIndex < 0) return format === 'ground';
          return String(v.options[grindIndex]).toLowerCase() === grind;
        });
        card.hidden = true;
        if (variant) matches.push({ card:card, variant:variant, item:item, score:card.dataset.flavor === flavor ? 10 : 1 });
      });
      matches.sort(function (a,b) { return b.score-a.score; });
      matches.slice(0,3).forEach(function (match) {
        match.card.hidden = false;
        match.card.querySelector('[data-vs-result-price]').textContent = match.variant.price;
        match.card.querySelector('[data-vs-result-link]').href = match.item.url + '?variant=' + match.variant.id;
      });
      status.textContent = matches.length ? status.dataset.results : status.dataset.empty;
      if (window.dataLayer) window.dataLayer.push({event:'coffee_finder_complete',brew_method:brew,flavor_preference:flavor,coffee_format:brew==='pods'?'pods':format});
    });
    form.elements.brew.addEventListener('change',function () {
      form.elements.format.disabled = this.value === 'pods';
    });
  }
  document.querySelectorAll('[data-vs-finder]').forEach(initialize);
  document.addEventListener('shopify:section:load',function (event) {
    event.target.querySelectorAll('[data-vs-finder]').forEach(initialize);
  });
})();
